import { createFileRoute } from "@tanstack/react-router";
import { TermsPage } from "@/features/legal/pages";

/** Public terms of service (ALP-77). No sign-in. */
export const Route = createFileRoute("/terms")({
  head: () => ({ meta: [{ title: "Terms of service · Malfak" }] }),
  component: TermsPage,
});
